




















import { Component, Prop, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component({
  model: {
    prop: 'checked',
    event: 'change'
  }
})
export default class AtomCheckBox extends ComponentVue {
  @Prop({ type: String })
  name!: string

  @Prop({ type: String })
  label!: string

  @Prop({ type: [Boolean, Array] })
  checked!: boolean | string[] | number[]

  @Prop({ type: [Boolean, String, Number] })
  value!: boolean | string | number

  @Prop({ type: Boolean, default: false })
  small!: boolean

  @Prop({ type: Boolean, default: false })
  disabled!: boolean

  @Prop({ type: Number, default: 500 })
  emitIntervalMs!: number

  isEmit: boolean = true

  get internalValue(): boolean | string[] | number[] {
    return this.checked
  }

  set internalValue(newVal: boolean | string[] | number[]) {
    this.$emit('change', newVal)
  }

  onKeydownEnter() {
    if (this.isEmit) {
      this.$emit('keydown:enter')
      this.isEmit = false

      setTimeout(() => (this.isEmit = true), this.emitIntervalMs)
    }
  }

  @Emit('click')
  onClick(): void {}
}
